import React from 'react';
export var MediaQueryContext = React.createContext({
    isMediumOrLarger: false,
    isLarger: false,
    isMax: false,
});
